export const Archivistico_item = [
  {
    archivistico_item_nombre: " 2026",
    archivistico_item_url: "../../../contenido/informacion/PADA SSH 2026.pdf",
    archivistico_item_titulo: "Año 2026"
  },
  {
    archivistico_item_nombre: " 2025",
    archivistico_item_url: "../../../contenido/informacion/PADA SSH 2025.pdf",
    archivistico_item_titulo: "Año 2025"
  },
  {
    archivistico_item_nombre: " 2023",
    archivistico_item_url: "../../../contenido/informacion/PADA 2023 SSH.pdf",
    archivistico_item_titulo: "Año 2023"
  },
];
